import styled, { css } from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { Button, fontWeight, FontWeights, minWidth, OptionalBackgroundButton } from '@calm-web/design-system';

export const Wrapper = styled.div<{ compact?: boolean }>`
	margin-top: auto;
	padding-top: 16px;
	width: 100%;

	${minWidth('desktopLarge')} {
		position: static;
		margin-top: 72px;
	}

	${ifProp(
		'compact',
		css`
			margin-bottom: 0;
		`,
	)}
`;

export const ContinueButton = styled(Button)<{ compact?: boolean }>`
	margin-bottom: 8px;

	${minWidth('tablet')} {
		margin-bottom: 16px;
	}

	${ifProp(
		'compact',
		css`
			background: ${palette('blue2')};
			color: ${palette('white')};
		`,
	)}
`;

export const SkipButton = styled(OptionalBackgroundButton)<{
	isDark?: boolean;
	isTransparentSkip?: boolean;
}>`
	border: 2px solid ${palette('gray3')};
	background: ${ifProp('isTransparentSkip', 'transparent', 'rgba(0, 0, 0, 0.3)')};
	color: ${ifProp('isTransparentSkip', palette('gray7'), palette('white'))};
	${fontWeight(FontWeights.Regular)};
`;
